import styled from 'styled-components';

export const InputWrapper = styled.div`
  width: 100%;
  margin: ${({ theme }) => theme.spacing.x2};
  display: flex;
  justify-content: center;
`;
